'use strict';

module.exports = require('../services/createErrorClass')({
	name: 'InvalidPrivateToken',
	message: "The provided private token did not match the user's private token.",
	soft: true
});
